/* global FormData */
/* global localStorage */
import ErrorMessage from "../../components/ErrorMessage";
import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { apiGet, apiPost, apiPut } from "../../utils/apiFetch";
import pathObj from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import OButton from "components/reusable/OButton";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import OInputField from "components/reusable/OInputField";
import OSelect from "components/reusable/OSelect";

const MortgageSetting = () => {
  const [banks, setBanks] = useState([]);
  const [bankId, setBankId] = useState(null);
  const { logoutUser, user, config, setCountry } = useContext(AuthContext);
  const permission =
    user?.permission?.find((e) => e.manager === "mortgageSettings") ?? {};
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { isDirty, errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {},
  });

  const {
    register: registerBank,
    handleSubmit: handleSubmitBank,
    setValue: setValueBank,
    getValues: getValuesBank,
    watch: watchBank,
    formState: { isDirty: isDirtyBank, errors: errorsBank },
  } = useForm({
    // mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {},
  });

  const [settingChangeLoading, setSettingChangeLoading] = useState(false);
  const notification = useToastContext();
  const [isDisable, setIsDisable] = useState(true);

  const handleSubmitForm = async (data) => {
    try {
      const sendData = {
        bankId: bankId,
        bankName: data?.bankName,
        bankNameAr: data?.bankNameAr,
        interestRate: data?.interestRate,
        minDownPaymentPercentage: data?.minDownPaymentPercentage,
        maxDownPaymentPercentage: data?.maxDownPaymentPercentage,
        LandDepartmentFee: {
          PropertyPercentage: data?.propertyPercentage,
          AdminFee: data?.landAdminFee,
        },
        RegistrationFee: {
          UptoTwoLac: {
            Price: data?.uptoPrice,
            VAT: data?.uptoVAT,
          },
          AboveFiveLac: {
            Price: data?.abovePrice,
            VAT: data?.aboveVAT,
          },
        },
        MortgageRegistrationFee: {
          LoanAmountPercentage: data?.loanAmountPercentage,
          AdminFee: data?.mortgageAdminFee,
        },
        RealEstateAgencyFee: {
          PropertyValuePercentage: data?.propertyValuePercentage,
          VATPercentage: data?.VATPercentage,
        },
        BankArrangementFee: {
          LoanAmountPercentageMinimum: data?.loanAmountPercentageMinimum,
          LoanAmountPercentageMaximum: data?.loanAmountPercentageMaximum,
          VATPercentage: data?.bankVATPercentage,
        },
        ValuationFee: {
          Min: data?.ValuationFeeMin,
          Max: data?.ValuationFeeMax,
          Vat: data?.ValuationFeeVat,
        },
      };

      setSettingChangeLoading(true);
      const res = await apiPut(pathObj.mortgageSetting, sendData);
      if (res.data.success === true) {
        getSettings();
        getBanks();
        notification.success(res?.data?.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setSettingChangeLoading(false);
    }
  };

  const getSettings = async () => {
    try {
      const res = await apiGet(pathObj.mortgageSetting + "?bankId=" + bankId);
      if (res) {
        const result = res?.data?.results;
        setValue("bankName", result?.bankName);
        setValue("bankNameAr", result?.bankNameAr);
        setValue("interestRate", result?.interestRate);
        setValue("uptoPrice", result?.RegistrationFee?.UptoTwoLac?.Price);
        setValue("uptoVAT", result?.RegistrationFee?.UptoTwoLac?.VAT);
        setValue("abovePrice", result?.RegistrationFee?.AboveFiveLac?.Price);
        setValue("aboveVAT", result?.RegistrationFee?.AboveFiveLac?.VAT);
        setValue("minDownPaymentPercentage", result?.minDownPaymentPercentage);
        setValue("maxDownPaymentPercentage", result?.maxDownPaymentPercentage);
        if (localStorage.getItem("country") === "UAE") {
          setValue(
            "propertyPercentage",
            result?.LandDepartmentFee?.PropertyPercentage,
          );
          setValue("landAdminFee", result?.LandDepartmentFee?.AdminFee);
          setValue(
            "loanAmountPercentage",
            result?.MortgageRegistrationFee?.LoanAmountPercentage,
          );
          setValue(
            "mortgageAdminFee",
            result?.MortgageRegistrationFee?.AdminFee,
          );
          setValue(
            "propertyValuePercentage",
            result?.RealEstateAgencyFee?.PropertyValuePercentage,
          );
          setValue("VATPercentage", result?.RealEstateAgencyFee?.VATPercentage);
          setValue(
            "loanAmountPercentageMinimum",
            result?.BankArrangementFee?.LoanAmountPercentageMinimum,
          );
          setValue(
            "loanAmountPercentageMaximum",
            result?.BankArrangementFee?.LoanAmountPercentageMaximum,
          );
          setValue(
            "bankVATPercentage",
            result?.BankArrangementFee?.VATPercentage,
          );
          setValue("ValuationFeeMin", result?.ValuationFee?.Min);
          setValue("ValuationFeeMax", result?.ValuationFee?.Max);
          setValue("ValuationFeeVat", result?.ValuationFee?.Vat);
        } else if (localStorage.getItem("country") === "Saudi") {
          setValue(
            "propertyPercentage",
            result?.LandDepartmentFee?.PropertyPercentage,
          );
          setValue("landAdminFee", result?.LandDepartmentFee?.AdminFee);
          setValue(
            "propertyValuePercentage",
            result?.RealEstateAgencyFee?.PropertyValuePercentage,
          );
          setValue("VATPercentage", result?.RealEstateAgencyFee?.VATPercentage);
        }
        setCountry(localStorage.getItem("country"));
      }
    } catch (error) {
      console.log("error:", error);

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const getBanks = async () => {
    const res = await apiGet(pathObj.getMortgageSettingBanks);
    if (res.data.success === true) {
      setBanks(res?.data?.results);
    }
  };

  useEffect(() => {
    getSettings();
    getBanks();
  }, []);

  useEffect(() => {
    if (bankId) {
      getSettings();
    }
  }, [bankId]);

  const UAEdata = () => {
    return (
      <>
        <div className="mortgageText pb-1 text-gray-800 font-medium">
          {t("MORTGAGE_REGISTRATION_FEE")}
        </div>
        <div className="justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("LOAN_AMOUNT_PERCENTAGE")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="loanAmountPercentage"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("loanAmountPercentage", {
                  required: {
                    value: true,
                    message: "Please enter loan amount percentage.",
                  },
                  max: {
                    value: 100,
                    message: "Percentage not exceed then 100.",
                  },
                  min: {
                    value: 0,
                    message: "Minimum value must is 0.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.loanAmountPercentage?.message} />
          </div>
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("ADMIN_FEE")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="mortgageAdminFee"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("mortgageAdminFee", {
                  required: {
                    value: true,
                    message: "Please enter mortgage admin fee.",
                  },
                  maxLength: {
                    value: 30,
                    message: "Max limit is 30 characters.",
                  },
                  min: {
                    value: 1,
                    message: "Minimum value must is 1.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.mortgageAdminFee?.message} />
          </div>
        </div>

        <div className="mortgageText pb-1 text-gray-800 font-medium">
          {t("BANK_ARRANGEMENT_FEE")}
        </div>
        <div className="justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("LOAN_AMOUNT_PERCENTAGE_MINIMUM")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="loanAmountPercentageMinimum"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("loanAmountPercentageMinimum", {
                  required: {
                    value: true,
                    message: "Please enter minimum loan amount percentage.",
                  },
                  max: {
                    value: 100,
                    message: "Percentage not exceed then 100.",
                  },
                  min: {
                    value: 0,
                    message: "Minimum value must is 0.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage
              message={errors?.loanAmountPercentageMinimum?.message}
            />
          </div>
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("LOAN_AMOUNT_PERCENTAGE_MAXIMUM")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="loanAmountPercentageMaximum"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("loanAmountPercentageMaximum", {
                  required: {
                    value: true,
                    message: "Please enter maximum loan amount percentage.",
                  },
                  max: {
                    value: 100,
                    message: "Percentage not exceed then 100.",
                  },
                  min: {
                    value: 0,
                    message: "Minimum value must is 0.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage
              message={errors?.loanAmountPercentageMaximum?.message}
            />
          </div>
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("VAT_PERCENTAGE")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="bankVATPercentage"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("bankVATPercentage", {
                  required: {
                    value: true,
                    message: "Please enter VAT Percentage.",
                  },
                  max: {
                    value: 100,
                    message: "Percentage not exceed then 100.",
                  },
                  min: {
                    value: 0,
                    message: "Minimum value must is 0.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.bankVATPercentage?.message} />
          </div>
        </div>

        <div className="mortgageText pb-1 text-gray-800 font-medium">
          {t("VALUATION_FEE")}
        </div>
        <div className="justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("O_MINIMUM")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="ValuationFeeMin"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("ValuationFeeMin", {
                  required: {
                    value: true,
                    message: "Please enter minimum valuation Fee.",
                  },
                  maxLength: {
                    value: 30,
                    message: "Max limit is 30 characters.",
                  },
                  min: {
                    value: 1,
                    message: "Minimum value must is 1.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.ValuationFeeMin?.message} />
          </div>
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("O_MAXIMUM")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="ValuationFeeMax"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("ValuationFeeMax", {
                  required: {
                    value: true,
                    message: "Please enter maximum valuation Fee.",
                  },
                  maxLength: {
                    value: 30,
                    message: "Max limit is 30 characters.",
                  },
                  min: {
                    value: 1,
                    message: "Minimum value must is 1.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.ValuationFeeMax?.message} />
          </div>
          <div className="  w-full">
            <div className="flex">
              <OInputField
                wrapperClassName="relative z-0 mb-6  w-full group"
                inputLabel={
                  <>
                    {t("DOWN_PAYMENT_PERCENTAGE")}
                    <span className="text-red-500">*</span>
                  </>
                }
                type="text"
                id="ValuationFeeVat"
                onKeyDown={(event) => {
                  if (
                    !["Backspace", "Delete", "Tab"].includes(event.key) &&
                    !/^\d*\.?\d*$/.test(event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                register={register("ValuationFeeVat", {
                  required: {
                    value: true,
                    message: "Please enter down payment percentage.",
                  },
                  max: {
                    value: 100,
                    message: "Percentage not exceed then 100.",
                  },
                  min: {
                    value: 0,
                    message: "Minimum value must is 0.",
                  },
                })}
                placeholder=" "
              />
            </div>
            <ErrorMessage message={errors?.ValuationFeeVat?.message} />
          </div>
        </div>
      </>
    );
  };

  const handleSubmitBankForm = async (data) => {
    setSettingChangeLoading(true);
    const res = await apiPost(pathObj.addMortgageSettingBank, data);
    if (res.data.success === true) {
      notification.success(res?.data?.message);
    } else {
      notification.error(res?.data?.message);
    }
    setSettingChangeLoading(false);
    setValueBank("bankName", "");
    getBanks();
  };

  return (
    <section className="">
      <form onSubmit={handleSubmit(handleSubmitForm)} method="post">
        <section className="sm:px-8 px-4 py-4 ">
          <div className="border xl:w-full round">
            <header className="border-b  py-2 px-4 bg-gray-100 rounded-t-md ">
              <div className="font-semibold">{t("NAV_MORTGAGE_SETTINGS")}</div>
            </header>

            <div className="bg-white py-6 px-4  rounded-b-md">
              <div className="flex flex-col gap-2 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white">
                    {t("BANK")}
                    <span className="text-red-500">*</span>
                  </label>
                </div>
                <select
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  inputLabel={
                    <>
                      {t("BANK")}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  disabled={!(permission?.add || user?.role === "admin")}
                  removeDefault={true}
                  onChange={(e) => setBankId(e.target.value)}
                  name="bankId"
                >
                  {banks.map((bank) => (
                    <option key={bank._id} value={bank._id}>
                      {bank.bankName || "Default"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="justify-center flex-wrap grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
                {watch("bankName") && (
                  <>
                    <div className="w-full">
                      <div className="flex">
                        <OInputField
                          name="bankName"
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("BANK_NAME")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          disabled={
                            !(permission?.add || user?.role === "admin")
                          }
                          type="text"
                          register={register("bankName", {
                            required: {
                              value: true,
                              message: "Please enter bank name.",
                            },
                            maxLength: {
                              value: 100,
                              message: "Max limit is 100 characters.",
                            },
                          })}
                          placeholder=""
                        />
                      </div>
                      <ErrorMessage message={errors?.bankName?.message} />
                    </div>
                    <div className="w-full">
                      <div className="flex">
                        <OInputField
                          name="bankNameAr"
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("BANK_NAME")} {t("AR")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          disabled={
                            !(permission?.add || user?.role === "admin")
                          }
                          type="text"
                          register={register("bankNameAr", {
                            required: {
                              value: true,
                              message: "Please enter bank name.",
                            },
                            maxLength: {
                              value: 100,
                              message: "Max limit is 100 characters.",
                            },
                          })}
                          placeholder=""
                        />
                      </div>
                      <ErrorMessage message={errors?.bankNameAr?.message} />
                    </div>
                  </>
                )}
                <div className="w-full">
                  <div className="flex">
                    <OInputField
                      name="interestRate"
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("INTEREST_RATE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      disabled={!(permission?.add || user?.role === "admin")}
                      type="text"
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("interestRate", {
                        required: {
                          value: true,
                          message: "Please enter interest rate.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                      })}
                      placeholder=""
                    />
                  </div>
                  <ErrorMessage message={errors?.interestRate?.message} />
                </div>
                <div className="w-full">
                  <div className="flex">
                    <OInputField
                      name="minDownPaymentPercentage"
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("MIN_DOWN_PAYMENT_PERCENTAGE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      disabled={!(permission?.add || user?.role === "admin")}
                      type="text"
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("minDownPaymentPercentage", {
                        required: {
                          value: true,
                          message:
                            "Please enter minimum down payment percentage.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                      })}
                      placeholder=""
                    />
                  </div>
                  <ErrorMessage
                    message={errors?.minDownPaymentPercentage?.message}
                  />
                </div>
                <div className="  w-full">
                  <div className="flex">
                    <OInputField
                      name="maxDownPaymentPercentage"
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("MAX_DOWN_PAYMENT_PERCENTAGE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      disabled={!(permission?.add || user?.role === "admin")}
                      type="text"
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("maxDownPaymentPercentage", {
                        required: {
                          value: true,
                          message:
                            "Please enter maximum down payment percentage.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                      })}
                      placeholder=""
                    />
                  </div>
                  <ErrorMessage
                    message={errors?.maxDownPaymentPercentage?.message}
                  />
                </div>
              </div>
              <div className="mortgageText pb-1 text-gray-800 font-medium">
                {t("LAND_DEPARTMENT_FEE")}
              </div>
              <div className="justify-center flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
                <div className="  w-full">
                  <div className="flex">
                    <OInputField
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("PROPERTY_PERCENTAGE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      disabled={!(permission?.add || user?.role === "admin")}
                      type="text"
                      id="propertyPercentage"
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("propertyPercentage", {
                        required: {
                          value: true,
                          message: "Please enter property percentage.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                      })}
                      placeholder=" "
                    />
                  </div>
                  <ErrorMessage message={errors?.propertyPercentage?.message} />
                </div>
                {config?.country === "UAE" ? (
                  <div className=" w-full">
                    <div className="flex">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        inputLabel={
                          <>
                            {t("ADMIN_FEE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        disabled={!(permission?.add || user?.role === "admin")}
                        type="text"
                        id="landAdminFee"
                        onKeyDown={(event) => {
                          if (
                            !["Backspace", "Delete", "Tab"].includes(
                              event.key,
                            ) &&
                            !/^\d*\.?\d*$/.test(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        register={register("landAdminFee", {
                          required: {
                            value: true,
                            message: "Please enter land admin fee.",
                          },
                          maxLength: {
                            value: 30,
                            message: "Max limit is 30 characters.",
                          },
                          min: {
                            value: 1,
                            message: "Minimum value must is 1.",
                          },
                        })}
                        placeholder=" "
                      />
                    </div>
                    <ErrorMessage message={errors?.landAdminFee?.message} />
                  </div>
                ) : (
                  <div className="  w-full">
                    <div className="flex">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        inputLabel={
                          <>
                            {t("VAT_PERCENTAGE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        disabled={!(permission?.add || user?.role === "admin")}
                        type="text"
                        id="landAdminFee"
                        onKeyDown={(event) => {
                          if (
                            !["Backspace", "Delete", "Tab"].includes(
                              event.key,
                            ) &&
                            !/^\d*\.?\d*$/.test(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        register={register("landAdminFee", {
                          required: {
                            value: true,
                            message: "Please enter VAT percentage.",
                          },
                          max: {
                            value: 100,
                            message: "Percentage not exceed then 100.",
                          },
                          min: {
                            value: 0,
                            message: "Minimum value must is 0.",
                          },
                        })}
                        placeholder=" "
                      />
                    </div>
                    <ErrorMessage message={errors?.landAdminFee?.message} />
                  </div>
                )}
              </div>
              <div className="mortgageText pb-1 text-gray-800 font-medium">
                {t("REAL_ESTATE_AGENT_FEE")}
              </div>
              <div className="justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
                <div className="  w-full">
                  <div className="flex">
                    <OInputField
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("PROPERTY_VALUE_PERCENTAGE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      id="propertyValuePercentage"
                      disabled={!(permission?.add || user?.role === "admin")}
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("propertyValuePercentage", {
                        required: {
                          value: true,
                          message: "Please enter property value percentage.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                      })}
                      placeholder=" "
                    />
                  </div>
                  <ErrorMessage
                    message={errors?.propertyValuePercentage?.message}
                  />
                </div>
                <div className="  w-full">
                  <div className="flex">
                    <OInputField
                      wrapperClassName="relative z-0 mb-6  w-full group"
                      inputLabel={
                        <>
                          {t("VAT_PERCENTAGE")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      id="VATPercentage"
                      disabled={!(permission?.add || user?.role === "admin")}
                      onKeyDown={(event) => {
                        if (
                          !["Backspace", "Delete", "Tab"].includes(event.key) &&
                          !/^\d*\.?\d*$/.test(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      register={register("VATPercentage", {
                        required: {
                          value: true,
                          message: "Please enter VAT percentage.",
                        },
                        max: {
                          value: 100,
                          message: "Percentage not exceed then 100.",
                        },
                        min: {
                          value: 0,
                          message: "Minimum value must is 0.",
                        },
                      })}
                      placeholder=" "
                    />
                  </div>
                  <ErrorMessage message={errors?.VATPercentage?.message} />
                </div>
              </div>

              {config?.country === "UAE" && (
                <>
                  <div className="mortgageText pb-1 text-gray-800 font-medium">
                    {t("REGISTRATION_FEE")}
                  </div>
                  <div className="justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4">
                    <div className="  w-full">
                      <div className="flex">
                        <OInputField
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("O_PRICE") + t("UP_TO_TWO_LACK")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          id="uptoPrice"
                          onKeyDown={(event) => {
                            if (
                              !["Backspace", "Delete", "Tab"].includes(
                                event.key,
                              ) &&
                              !/^\d*\.?\d*$/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          register={register("uptoPrice", {
                            required: {
                              value: true,
                              message: "Please enter price.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Max limit is 30 characters.",
                            },
                            min: {
                              value: 1,
                              message: "Minimum value must is 1.",
                            },
                          })}
                          placeholder=" "
                        />
                      </div>
                      <ErrorMessage message={errors?.uptoPrice?.message} />
                    </div>
                    <div className="  w-full">
                      <div className="flex">
                        <OInputField
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("O_VAT") + t("UP_TO_TWO_LACK")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          id="uptoVAT"
                          onKeyDown={(event) => {
                            if (
                              !["Backspace", "Delete", "Tab"].includes(
                                event.key,
                              ) &&
                              !/^\d*\.?\d*$/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          register={register("uptoVAT", {
                            required: {
                              value: true,
                              message: "Please enter VAT.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Max limit is 30 characters.",
                            },
                            min: {
                              value: 1,
                              message: "Minimum value must is 1.",
                            },
                          })}
                          placeholder=" "
                        />
                      </div>
                      <ErrorMessage message={errors?.uptoVAT?.message} />
                    </div>
                    <div className="  w-full">
                      <div className="flex">
                        <OInputField
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("O_PRICE") + t("ABOVE_FIVE_LACK")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          id="abovePrice"
                          onKeyDown={(event) => {
                            if (
                              !["Backspace", "Delete", "Tab"].includes(
                                event.key,
                              ) &&
                              !/^\d*\.?\d*$/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          register={register("abovePrice", {
                            required: {
                              value: true,
                              message: "Please enter price.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Max limit is 30 characters.",
                            },
                            min: {
                              value: 1,
                              message: "Minimum value must is 1.",
                            },
                          })}
                          placeholder=" "
                        />
                      </div>
                      <ErrorMessage message={errors?.abovePrice?.message} />
                    </div>
                    <div className="  w-full">
                      <div className="flex">
                        <OInputField
                          wrapperClassName="relative z-0 mb-6  w-full group"
                          inputLabel={
                            <>
                              {t("O_VAT") + t("ABOVE_FIVE_LACK")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          id="aboveVAT"
                          onKeyDown={(event) => {
                            if (
                              !["Backspace", "Delete", "Tab"].includes(
                                event.key,
                              ) &&
                              !/^\d*\.?\d*$/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          register={register("aboveVAT", {
                            required: {
                              value: true,
                              message: "Please enter VAT.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Max limit is 30 characters.",
                            },
                            min: {
                              value: 1,
                              message: "Minimum value must is 1.",
                            },
                          })}
                          placeholder=" "
                        />
                      </div>
                      <ErrorMessage message={errors?.aboveVAT?.message} />
                    </div>
                  </div>
                </>
              )}

              {config?.country === "UAE" ? <UAEdata /> : null}
            </div>
          </div>
        </section>

        {(permission?.add || user?.role === "admin") && (
          <div className="text-center mt-4">
            <OButton
              disabled={!isDirty && isDisable}
              label={<>{t("O_UPDATE")}</>}
              type="submit"
              loading={settingChangeLoading}
            />
          </div>
        )}
      </form>
      {(permission?.add || user?.role === "admin") && (
        <section className="sm:px-8 px-4 py-4 ">
          <div className="border xl:w-full round">
            <header className="border-b  py-2 px-4 bg-gray-100 rounded-t-md ">
              <div className="font-semibold">{t("ADD_BANK")}</div>
            </header>
            <form onSubmit={handleSubmitBank(handleSubmitBankForm)}>
              <div className="p-4">
                <div className="">
                  <OInputField
                    name="bankName"
                    wrapperClassName="relative z-0 mb-6  w-full group"
                    inputLabel={
                      <>
                        {t("BANK_NAME")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={registerBank("bankName", {
                      required: "Please enter bank name.",
                    })}
                    placeholder=""
                  />
                  <ErrorMessage message={errors?.bankName?.message} />
                </div>
                <div className="flex justify-end mt-2">
                  <OButton
                    label={<>{t("O_ADD")}</>}
                    type="submit"
                    loading={settingChangeLoading}
                  />
                </div>
              </div>
            </form>
          </div>
        </section>
      )}
    </section>
  );
};

export default MortgageSetting;
